import type { HTTPQuery } from '@nomiss/sdk';

type QueryValue =
  | string
  | number
  | null
  | undefined
  | boolean
  | Array<string | number | null | boolean>
  | Set<string | number | null | boolean>
  | HTTPQuery;

/**
 * NestJS list query DTOs expect one comma-separated param
 * (e.g. leagueCodes=ipl,bbl). The default OpenAPI client emits
 * repeated keys (leagueCodes=ipl&leagueCodes=bbl), which the API rejects.
 */
export function commaSeparatedQuerystring(
  params: HTTPQuery,
  prefix = '',
): string {
  return Object.keys(params)
    .map(key => commaSeparatedQuerystringSingleKey(key, params[key], prefix))
    .filter(part => part.length > 0)
    .join('&');
}

function commaSeparatedQuerystringSingleKey(
  key: string,
  value: QueryValue,
  keyPrefix = '',
): string {
  const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);

  if (value instanceof Array) {
    const joined = value
      .map(item => String(item))
      .filter(item => item.length > 0)
      .join(',');

    if (joined.length === 0) {
      return '';
    }

    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(joined)}`;
  }

  if (value instanceof Set) {
    return commaSeparatedQuerystringSingleKey(key, Array.from(value), keyPrefix);
  }

  if (value instanceof Date) {
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
  }

  if (value instanceof Object) {
    return commaSeparatedQuerystring(value as HTTPQuery, fullKey);
  }

  if (value === null || value === undefined) {
    return '';
  }

  return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
